"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _HiFormControl = _interopRequireDefault(require("./HiFormControl"));
var _HiInput = _interopRequireDefault(require("./HiInput"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent TextField
/**
 * Champs input pour formulaire
 */
var HiTextField = /*#__PURE__*/function (_React$PureComponent) {
  function HiTextField(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiTextField);
    _this = _callSuper(this, HiTextField, [props]);
    _this.focus = function () {
      _this.input.focus();
    };
    _this.state = {
      nbChars: props.value ? props.value.length : 0
    };
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiTextField, _React$PureComponent);
  return (0, _createClass2.default)(HiTextField, [{
    key: "handleBlur",
    value: function handleBlur(event) {
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var value = event.target.value;
      if (value.length <= this.props.maxLength) {
        if (this.props.onChange) {
          this.props.onChange(event);
        }
        if (this.props.multiline === true) {
          this.setState({
            nbChars: value.length
          });
        }
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        disabled = _this$props.disabled,
        error = _this$props.error,
        errorText = _this$props.errorText,
        id = _this$props.id,
        label = _this$props.label,
        helperText = _this$props.helperText,
        helperIcon = _this$props.helperIcon,
        fullWidth = _this$props.fullWidth,
        required = _this$props.required,
        type = _this$props.type,
        multiline = _this$props.multiline,
        placeholder = _this$props.placeholder,
        value = _this$props.value,
        HiInputProps = _this$props.HiInputProps,
        HiInputLabelProps = _this$props.HiInputLabelProps,
        name = _this$props.name,
        rows = _this$props.rows,
        maxLength = _this$props.maxLength,
        customRef = _this$props.customRef;
      var nbChars = this.state.nbChars;
      return /*#__PURE__*/_react.default.createElement(_HiFormControl.default, {
        label: label,
        required: required,
        disabled: disabled,
        className: className,
        error: error,
        id: id,
        errorText: errorText,
        helperText: helperText,
        helperIcon: helperIcon,
        multiline: multiline,
        maxLength: maxLength,
        nbChars: nbChars,
        InputLabelProps: HiInputLabelProps
      }, /*#__PURE__*/_react.default.createElement(_HiInput.default, (0, _extends2.default)({
        inputId: id,
        name: name,
        type: type,
        placeholder: placeholder,
        value: value,
        disabled: disabled,
        error: error,
        multiline: multiline,
        fullWidth: fullWidth,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onReset: this.props.onReset,
        onFocus: this.handleFocus,
        onRightIconClick: this.props.onRightIconClick,
        onLeftIconClick: this.props.onLeftIconClick,
        rows: rows,
        customRef: customRef,
        inputRef: function inputRef(input) {
          _this2.input = input;
        }
      }, HiInputProps)));
    }
  }]);
}(_react.default.PureComponent);
HiTextField.defaultProps = {
  name: '',
  type: 'text',
  fullWidth: true,
  required: true,
  disabled: false,
  error: false,
  errorText: '',
  helperText: '',
  helperIcon: false,
  multiline: false,
  maxLength: 280
};
var _default = exports.default = HiTextField;